import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
import MultiSelect from "../modules/MultiSelect";
import DropBtn from "../modules/DropBtn";
import avatar from "../../Assets/svg/avatar-img.svg";
import phone from "../../Assets/svg/phone.svg";
import mail from "../../Assets/svg/mail.svg";
import ConnectionListView from "./ConnectionListView";
import MentorListView from "../Connect/MentorListView";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { addMentorInfo, resetClear } from "../Connect/redux/actions";
import ModalComponent from "../modules/Modal";
import { Input } from "@mui/material";
import RatingSize from "../modules/Stars";
import tick2 from "../../Assets/svg/wave tick icon.svg";
import tick from "../../Assets/svg/green-bg-tick.svg";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";

function Connections() {
  const [universities, setuniversities] = useState([]);
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "",
    countDown: " ",
    desc: "",
  });
  const [msg, setMsg] = useState("");
  const [modelOptions, setModel] = useState([
    "Resume Building",
    "Job and Internship application",
    "Networking Skills",
    "Job Interviews",
    "Academics",
    "Something else",
  ]);
  const [requestOption, setRequestOption] = useState({
    topic: "",
    message: "",
    reason: "",
  });
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [btnList, setBtnList] = useState([
    { title: "Communcation", selected: false },
    { title: "Topic at hand", selected: false },
    { title: "Knowledge", selected: false },
    { title: "Friendliness", selected: false },
    { title: "Punctuality", selected: false },
    { title: "Others", selected: false },
  ]);
  const [id, setId] = useState();
  const [callType, setCallType] = useState("");

  const dispatch = useDispatch();
  const scholars = useSelector((state) => state.connect.myScholars);
  const [uploading, setUploading] = useState(false);
  const [rating, setRating] = useState({
    stars: "",
    options: [],
    feedback: "",
  });
  const tokenData = useSelector((state) => state.tokens.tokens);

  const getScholars = async () => {
    try {
      const scholarData = await api.getMyAlumnis(
        tokenData.token,
        false,
        tokenData.applicationData.id
      );
      if (scholarData.statusCode == 200) {
        dispatch(
          addMentorInfo({
            type: "myScholars",
            value:scholarData?.data ? [
              ...scholarData?.data?.sort((a, b) => a?.id - b?.id)?.reverse(),
            ]:[],
          })
        );
      // }else{
      //   dispatch(
      //     addMentorInfo({
      //       type: "myScholars",
      //       value: [],
      //     })
      //   );
      }
      // if (mentorData.data) {
      //   dispatch(addMentorInfo([...mentorData.data]));
      // }
      console.log("scholarData", scholarData);
    } catch (err) {
      console.log("err", err);
    }
  };
  const feedbackContent = () => {
    let item = scholars.filter((a) => a.requestId === id)[0];
    // setProffInfo({ ...content });
    return (
      <div className="feedback-content">
        <div className="mentor-info">
          {/* <img src={avatar} alt="avatar" /> */}
          <div className="image img-section">
            {/* <img src={avatar} alt="avatar" /> */}
            {item?.image && item?.imageExtension && (
              <img
                // className="image"
                src={
                  "data:image/" +
                  item?.imageExtension +
                  ";base64," +
                  item?.image
                }
                alt="Preview"
                // style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          </div>
          <div className="mentor-text">
            <span className="option-text">{item?.fullName}</span>
            <span className="upload-top-text">{item?.expertise}</span>
          </div>
        </div>
        <div className="stars sub-option-text">
          {/* How was your overall experience? */}
          <RatingSize
            value={rating.stars}
            onChange={(e) => setRating({ ...rating, stars: e })}
          />
        </div>
        {rating.stars > 0 && (
          <div className="multi-btns">
            <div className="sub-option-text">
              What does this feedback pertain to?
              <div className="buttons-set">
                {btnList.map((item, index) => (
                  <div
                    onClick={() =>
                      setRating({
                        ...rating,
                        options: [...rating.options, item?.title],
                      })
                    }
                    className={` sub-option-text ${
                      rating.options.includes(item?.title)
                        ? "contained"
                        : "btn-option"
                    }`}
                  >
                    {item?.title}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {rating?.options?.length > 0 && (
          <div className="comment-field">
            <Input
              onChange={(e) =>
                setRating({
                  ...rating,
                  feedback: e.replace(/[^a-zA-Z0-9. ]/g, ""),
                })
              }
              placeholder={"Could you tell us a little more?"}
              multiline={true}
            />
          </div>
        )}
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            // disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Go back"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => checkRequest()}
            value={"Send"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };
  const cancelContent = () => {
    return (
      <div className="feedback-content">
        <div className="comment-field">
          <Input
            onChange={(e) => setRequestOption({ ...requestOption, reason: e.replace(/[^a-zA-Z0-9. ]/g, "") })}
            placeholder={"Write your message"}
            multiline={true}
          />
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Cancel"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => checkRequest()}
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            // disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Send"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const makeRequest = async () => {
    let item = scholars.filter((a) => a.requestId === id)[0];

    // console.log("in checkModified after timer");
    // let noNullData=replaceNullsWithEmptyStrings(cleanObjectStrings(CombineData()))
    let data = {
      id: item.requestId,
      receiverApplicationId: item?.applicationId,
      senderApplicationId: tokenData.applicationData.id,
      status: callType === "Request again" ? "Pending" : callType,
      requestCancelReason:
        typeof requestOption.reason !== "string"
          ? requestOption?.reason?.target?.value
          : requestOption.reason !== ""
          ? requestOption.reason
          : item?.sessionCancelReason,
      feedbackPertainTo:
        (rating.options.length === 1
          ? rating.options[0]
          : rating.options.join(",")) || item?.studentFeedbackPertainTo,
      review: rating.stars || item?.studentReview,
      feedback: rating.feedback || item?.studentFeedback,
      message:
        typeof msg !== "string" ? msg?.target?.value : msg !== "" ? msg : "",
    };

    try {
      const request = await api.updateAlumni(tokenData.token, data);
      console.log("users", request);
      if (request.statusCode !== 200 && request.data.includes("Session expired")) {
        logoutMsg();
      }
      return request;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (error?.data?.includes("Session expired")) {
        logoutMsg();
      }
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const checkRequest = async () => {
    setUploading(true);
    try {
      const request = await makeRequest();
      console.log("users", request);
      setUploading(false);
      if (request.statusCode == 200) {
        setModalData({
          ...ModalData,
          type: "submit",
          title:
            callType === "Cancel" ? (
              <div className="set-title">
                <div className="happy-icon">
                  <img src={tick2} alt="tick" />
                </div>
                Cancelled your session
              </div>
            ) : callType === "feedback" ? (
              <div className="set-title">
                <div className="happy-icon">
                  <img src={tick2} alt="tick" />
                </div>
                Thanks for the feedback!
              </div>
            ) : (
              <div className="set-title">
                <div className="happy-icon">
                  <img src={tick} alt="tick" />
                </div>
                Mentorship session request sent!
              </div>
            ),
          desc:
            callType === "Request again" &&
            "You’ll receive an update via email once your request is accepted.",
        });
        getScholars();
      }
    } catch (error) {
      console.error("Error", error);
      setUploading(false);

      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const RequestAgain = () => {
    let item = scholars?.filter((a) => a.requestId === id)[0];

    return (
      <div className="feedback-content">
        <div className="mentor-info">
          <div className="image img-section">
            {/* <img src={avatar} alt="avatar" /> */}
            {item?.image && item?.imageExtension && (
              <img
                // className="image"
                src={
                  item?.image && item?.imageExtension
                    ? "data:image/" +
                      item?.imageExtension +
                      ";base64," +
                      item?.image
                    : null
                }
                alt="Preview"
                // style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          </div>
          <div
            className="mentor-text"
            style={{ marginLeft: "2%", justifyContent: "space-between" }}
          >
            <span className="set-title">{item?.name || item?.fullName}</span>
            <span className="md-desc" style={{ color: "#222222" }}>
              {item?.expertise}
            </span>
          </div>
        </div>
        <div className="comment-field">
          <Input
            onChange={
              (e) => setMsg(e.replace(/[^a-zA-Z0-9. ]/g, ""))
              // setFeedbackData("comment", e.replace(/[^a-zA-Z0-9. ]/g, ""))
            }
            placeholder={"Write your message"}
            multiline={true}
          />
        </div>
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Cancel"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => checkRequest()}
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            // disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Send"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };
  useEffect(() => {
    getScholars();
  }, []);
  console.log("my alumni", scholars);

  return (
    <div className="scholar-cards connections">
      {scholars?.map((item, index) => {
        return (
          <ConnectionListView
            setId={setId}
            ModalData={ModalData}
            //  setMentorId={setMentorId}
            setCallType={(e) => setCallType(e)}
            // checkRequest={(e) => checkRequest(e)}
            setModalData={(e) => setModalData(e)}
            key={index}
            item={item}
            sendRequest={() =>
              setModalData({
                ...ModalData,
                show: true,
                type: "request",
                title: "Request a Session",
              })
            }
          />
        );
      })}
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          content={ModalData.desc}
          className={"mentor-list"}
          noCross={
            (ModalData.type === "submit" || ModalData.type === "network") &&
            true
          }

          // countDown={ModalData.countDown}
        >
          {ModalData.type === "request" ? (
            RequestAgain()
          ) : ModalData.type === "cancel" ? (
            cancelContent()
          ) : ModalData.type === "rating" ? (
            feedbackContent()
          ) : (
            // : ModalData.type === "request"
            // ? RequestAgain()
            // ModalData.type === "network" ? (
            //   scholarContent()
            // ) :
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  show: false,
                })
              }
              value={"Okay"}
              type={"contained"}
            />
          )}
        </ModalComponent>
      )}
    </div>
  );
}

export default Connections;
